import { createAction, handleActions } from 'redux-actions';
import { pender } from 'redux-pender';
import * as api from 'app/api';
import produce from 'immer';
import set from 'lodash/set';

const GET_CENTER_LOCATION = 'encarcenter/GET_CENTER_LOCATION';
export const getCenterLocation = createAction(GET_CENTER_LOCATION, api.getCenterLocation);

const GET_CENTER_INFO = 'encarcenter/GET_CENTER_INFO';
export const getCenterInfo = createAction(GET_CENTER_INFO, api.getCenterInfo);

const GET_CENTER_DETAIL = 'encarcenter/GET_CENTER_DETAIL';
export const getCenterDetail = createAction(GET_CENTER_DETAIL, api.getCenterDetail);

const CHANGE = 'encarcenter/CHANGE';
export const change = createAction(CHANGE);

const initialState = {
	locationList: [],
	centerList: [],
	centerDetail: {},
	sendInfo: null,
	validation: {
		sendName: '',
		sendEmail: '',
		receiveName: '',
		receiveEmail: '',
		checked: false,
		sendNameValidationText: '',
		sendEmailValidationText: '',
		receiveNameValidationText: '',
		receiveEmailValidationText: '',
	},
	totalCount: 0,
};

export default handleActions(
	{
		[CHANGE]: (state, action) =>
			produce(state, (draft) => {
				const { schema, name, value } = action.payload;
				set(draft, [schema, name], value);
			}),

		...pender({
			type: GET_CENTER_LOCATION,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					set(draft, 'locationList', data || []);
				}),
		}),

		...pender({
			type: GET_CENTER_INFO,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					set(draft, 'centerList', data.list || []);
					set(draft, 'totalCount', data.totalCount);
				}),
		}),

		...pender({
			type: GET_CENTER_DETAIL,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					set(draft, 'centerDetail', data || {});
				}),
		}),
	},
	initialState,
);
